import ChartStyles from '@/utils/chart_styles';
import DoughnutLabelPlugin from '@/utils/doughnut_label_plugin';
import Chart from 'chart.js/auto';
import { Controller } from '@hotwired/stimulus';

Chart.register(DoughnutLabelPlugin);

export default class extends Controller {
  static targets = ['typeChart'];

  static values = {
    clientHours: Number,
    internalHours: Number,
    totalHours: Number,
  };

  connect() {
    if (!this.hasTypeChartTarget || this.totalHoursValue <= 0) { return; }

    this.buildChart();
  }

  disconnect() {
    this.chart?.destroy();
    this.chart = null;
  }

  buildChart() {
    const totalHours = this.totalHoursValue;

    this.chart = new Chart(this.typeChartTarget, {
      type: 'doughnut',
      data: {
        labels: ['Client Hours', 'Internal Hours'],
        datasets: [
          {
            data: [this.clientHoursValue, this.internalHoursValue],
            backgroundColor: [ChartStyles.colors.blue, ChartStyles.colors.yellow],
            borderColor: [ChartStyles.colors.blue, ChartStyles.colors.yellow],
            borderWidth: 0,
            hoverOffset: 4,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        devicePixelRatio: window.devicePixelRatio || 1,
        plugins: {
          crosshair: false,
          legend: { display: false },
          tooltip: {
            backgroundColor: ChartStyles.tooltips.backgroundColor,
            titleColor: ChartStyles.tooltips.titleFontColor,
            bodyColor: ChartStyles.tooltips.bodyFontColor,
            borderColor: ChartStyles.tooltips.borderColor,
            borderWidth: 1,
            callbacks: {
              label: (context) => {
                const value = context.raw;
                const percentage = ((value / totalHours) * 100).toFixed(1);
                return `${context.label}: ${value}h (${percentage}%)`;
              },
            },
          },
          doughnutlabel: {
            labels: [
              {
                text: this.formatHours(totalHours),
                font: { size: 18, weight: 'bold' },
              },
              {
                text: 'Total',
                font: { size: 12 },
                color: '#6c757d',
              },
            ],
          },
        },
        cutout: '60%',
        elements: {
          arc: { borderRadius: 2, borderWidth: 0 },
        },
      },
      plugins: [DoughnutLabelPlugin],
    });
  }

  formatHours(hours) {
    return hours % 1 === 0 ? hours.toString() : hours.toFixed(2);
  }
}
